import { streamRequest, StreamOptions } from '../http/sseClient'
import { PartnerType } from '@/app/utils/partners.enum'

export type ReceivedDate = {
  codigoDataRecebimentoId: number
  descricao: string
}

export async function getReceivedDates(
  type: PartnerType = PartnerType.CREFISA_INSS,
  options?: StreamOptions,
) {
  const data = await streamRequest<ReceivedDate[]>({
    method: 'GET',
    path: `/crefisa/received-dates?type=${type}`,
    ...options,
  })

  return data ?? []
}
